var _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgQuotesEnd = function SvgQuotesEnd(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 100 100",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.3 97.8C6.7 91.9 4.1 85.9 2.4 80 .8 74 0 68 0 62.1 0 51 2.7 40.4 8.2 30.2s13.1-19.5 23-28l10.2 6.3c1 .6 1.6 1.3 1.9 2s.5 1.5.5 2.2c0 1.7-.6 3.2-1.9 4.4q-3 3.75-5.7 7.8c-2.7 4.05-3.5 5.6-5 8.6s-2.6 6.2-3.5 9.5-1.3 6.8-1.3 10.5c0 3.9.6 8 1.8 12.2s3.2 8.6 6 13.3c.9 1.4 1.3 2.8 1.3 4.3 0 3-1.7 5.1-5 6.3zm56.2 0c-3.6-5.9-6.2-11.9-7.9-17.8-1.6-6-2.4-12-2.4-17.9 0-11.1 2.7-21.7 8.2-31.9s13.1-19.5 23-28l10.2 6.3c1 .6 1.6 1.3 1.9 2s.5 1.5.5 2.2c0 1.7-.6 3.2-1.9 4.4q-3 3.75-5.7 7.8c-2.7 4.05-3.5 5.6-5 8.6s-2.6 6.2-3.5 9.5-1.3 6.8-1.3 10.5c0 3.9.6 8 1.8 12.2s3.2 8.6 6 13.3c.9 1.4 1.3 2.8 1.3 4.3 0 3-1.7 5.1-5 6.3z"
  })));
};
export default SvgQuotesEnd;